import React from 'react';
import { ListItemButton, Typography, styled } from '@mui/material';
import { copyToClipboard } from 'lib/helpers';
import { useSnackbar } from 'notistack';

const PREFIX = 'OverwritesErrorMessage';

const classes = {
    root: `${PREFIX}-root`
};

const StyledListItem = styled(ListItemButton)(({ theme }) => ({
    [`&.${classes.root}`]: {
        padding: theme.spacing(1),
        borderBottom: `1px dotted ${theme.palette.divider}`,
        '&:last-child': {
            borderBottom: 'none'
        }
    }
}));

interface OverwritesErrorMessageProps {
    message: string;
}

const OverwritesErrorMessagePure: React.FC<OverwritesErrorMessageProps> = ({ message }) => {
    const { enqueueSnackbar } = useSnackbar();

    const handleClick = React.useCallback(() => {
        enqueueSnackbar(`"${message}" copied to the clipboard`, { variant: 'default' });
        copyToClipboard(message);
    }, [message, enqueueSnackbar]);
    return (
        <StyledListItem onClick={handleClick} className={classes.root}>
            <Typography variant="caption" sx={{ fontSize: '0.85rem' }}>
                {message}
            </Typography>
        </StyledListItem>
    );
};

export const OverwritesErrorMessage = React.memo(
    OverwritesErrorMessagePure,
    (l, r) => l.message !== r.message
);
